import styled from 'styled-components';

export default styled.div`
  background-color: #ffffffc4;
  border-radius: 50%;
`;
